import { StatusConfig } from "common";
import {
  BrokerUserListItemData,
  BrokerUserRole,
  BrokerUserStatus,
  BrokerUserStatusLabel,
} from "../../domain/models/broker-user.model";

export const BROKER_USER_LIST_ROLES: BrokerUserRole[] = [
  BrokerUserRole.Administrator,
  BrokerUserRole.User,
  BrokerUserRole.Developer,
  BrokerUserRole.None,
];

export const BrokerUserStatusConfig: StatusConfig = {
  [BrokerUserStatus.Active]: { color: "mat-green-bg", icon: "check_circle", label: BrokerUserStatusLabel.get(BrokerUserStatus.Active) },
  [BrokerUserStatus.Invited]: { color: "mat-orange-bg", icon: "mail", label: BrokerUserStatusLabel.get(BrokerUserStatus.Invited) },
  [BrokerUserStatus.Disabled]: { color: "mat-red-bg", icon: "block", label: BrokerUserStatusLabel.get(BrokerUserStatus.Disabled) },
  [BrokerUserStatus.None]: { color: "mat-grey-bg", icon: "no_accounts", label: BrokerUserStatusLabel.get(BrokerUserStatus.None) },
};

export interface BrokerUserListRow extends BrokerUserListItemData {
  isContact: boolean;
  displayStatus: BrokerUserStatus;
}

export const toBrokerUserListRow = (row: BrokerUserListItemData): BrokerUserListRow => {
  const isContact = row.role === BrokerUserRole.None;
  return {
    ...row,
    isContact,
    displayStatus: isContact && row.status !== BrokerUserStatus.Disabled ? BrokerUserStatus.None : row.status,
  };
};
